// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"7d433b04","453":"492161ed","606":"9e200e59"}[chunkId] + ".chunk.js";
};